// --------------- LIBRARIES ---------------
import { put, call, takeEvery, all } from "redux-saga/effects";
import { common } from "../../types";
import walletApis from "src/api/wallet";
import { constants } from "src/constants/common";
import * as actions from "../slices/walletSlice";

const FetchWalletOptionPlanSaga = function* FetchWalletOptionPlanSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      walletApis.fetchWalletOptionPlans,
      payload
    );
    if (response?.code === "-1") {
      throw new Error("Session Expire");
    } else if (response?.code === "0") {
      throw new Error(response?.message);
    }
    yield put(actions.fetchwalletOptionPlansSuccess(response));
    resolve(response);
  } catch (error) {
    yield put(
      actions.fetchwalletOptionPlansError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

const FetchWalletAmountSaga = function* FetchWalletAmountSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      walletApis.fetchWalletAmount,
      payload
    );
    if (response?.code === "-1") {
      throw new Error("Session Expire");
    } else if (response?.code === "0") {
      throw new Error(response?.message);
    }
    yield put(actions.fetchWalletAmountSuccess(response));
    resolve(response);
  } catch (error) {
    yield put(
      actions.fetchWalletAmountError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

const FetchWalletStatementSaga = function* FetchWalletStatementSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      walletApis.fetchWalletStatement,
      payload
    );
    if (response?.code === "-1") {
      throw new Error("Session Expire");
    } else if (response?.code === "0") {
      throw new Error(response?.message);
    }
    const tempPayload = {
      ...response,
      page_no: Number(payload.page_no),
      filter: payload.filter ?? undefined,
    };
    yield put(actions.fetchWalletStatementSuccess(tempPayload));
    resolve(tempPayload);
  } catch (error) {
    yield put(
      actions.fetchWalletStatementError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

const CreateWalletIdSaga = function* CreateWalletIdSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      walletApis.createWalletId,
      payload
    );
    if (response?.code === "-1") {
      throw new Error("Session Expire");
    } else if (response?.code === "0") {
      throw new Error(response?.message);
    }
    yield put(actions.createWalletIdSuccess(response));
    resolve(response);
  } catch (error) {
    yield put(
      actions.createWalletIdError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

const LoadWalletMoneySaga = function* LoadWalletMoneySaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      walletApis.loadMoneny,
      payload
    );
    if (response?.code === "-1") {
      throw new Error("Session Expire");
    } else if (response?.code === "0") {
      throw new Error(response?.message);
    }
    yield put(actions.loadWalletMoneySuccess(response));
    resolve(response);
  } catch (error) {
    yield put(
      actions.loadWalletMoneyError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

function* walletSaga() {
  yield all([
    takeEvery(actions.fetchWalletAmountRequest, FetchWalletAmountSaga),
  ]);
  yield all([
    takeEvery(actions.fetchWalletStatementRequest, FetchWalletStatementSaga),
  ]);
  yield all([takeEvery(actions.createWalletIdRequest, CreateWalletIdSaga)]);
  yield all([takeEvery(actions.loadWalletMoneyRequest, LoadWalletMoneySaga)]);
  yield all([
    takeEvery(actions.fetchwalletOptionPlansRequest, FetchWalletOptionPlanSaga),
  ]);
}

export default walletSaga;
